import { useEffect, useState } from "react";
import SpotifyWebApi from "spotify-web-api-js";
import { useTokenContext } from "src/auth/UserTokenProvider";

const spotifyApi = new SpotifyWebApi();

const useAlbumDetails = (albumId?: string) => {
  const { token, isLoading: tokenLoading } = useTokenContext();
  const [album, setAlbum] = useState<SpotifyApi.SingleAlbumResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAlbum = async () => {
      if (!albumId) {
        setAlbum(null);
        return;
      }
      if (!token?.value) {
        setAlbum(null);
        setLoading(tokenLoading);
        setError(tokenLoading ? null : "Spotify authentication is required");
        return;
      }

      try {
        spotifyApi.setAccessToken(token.value);
        setLoading(true);
        setError(null);
        setAlbum(await spotifyApi.getAlbum(albumId));
      } catch (err) {
        setError("Failed to fetch album");
      } finally {
        setLoading(false);
      }
    };

    fetchAlbum();
  }, [albumId, token?.value, tokenLoading]);

  return { album, loading, error };
};

export default useAlbumDetails;
